import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-gateway-timeout',
  templateUrl: './gateway-timeout.component.html',
  styleUrls: ['./gateway-timeout.component.scss'],
  standalone: false,
})
export class GatewayTimeoutComponent implements OnInit {
  private route = inject(ActivatedRoute);

  title: string;

  ngOnInit() {
    this.route.data.subscribe((d) => {
      this.title = d.title;
    });
  }
}
